import React from 'react';
import { Building2, Key, CreditCard, MessageSquare, ArrowRight } from 'lucide-react';
import { AnimateOnScroll } from './AnimateOnScroll';
export function QuickActions() {
  const actions = [{
    icon: <Building2 className="h-7 w-7" data-id="element-269" />,
    title: 'Property Owners',
    description: 'Maximize your investment with professional management services.',
    cta: 'Learn More',
    image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=600&q=80'
  }, {
    icon: <Key className="h-7 w-7" data-id="element-270" />,
    title: 'Find a Rental',
    description: 'Browse available properties across Fresno and the Central Valley.',
    cta: 'View Listings',
    image: 'https://images.unsplash.com/photo-1558036117-15d82a90b9b1?auto=format&fit=crop&w=600&q=80'
  }, {
    icon: <CreditCard className="h-7 w-7" data-id="element-271" />,
    title: 'Pay Rent / HOA',
    description: 'Make payments quickly and securely through our online portal.',
    cta: 'Make Payment',
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=600&q=80'
  }, {
    icon: <MessageSquare className="h-7 w-7" data-id="element-272" />,
    title: 'Maintenance Request',
    description: 'Submit and track maintenance requests for your property.',
    cta: 'Submit Request',
    image: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=600&q=80'
  }];
  return <section className="pt-16 pb-20 bg-background" data-id="element-273">
      <div className="container mx-auto px-4" data-id="element-274">
        <AnimateOnScroll data-id="element-275">
          <div className="text-center mb-14" data-id="element-276">
            <p className="text-[oklch(0.45_0.16_250)] font-medium text-sm uppercase tracking-widest mb-3" data-id="element-277">
              What We Offer
            </p>
            <h2 className="font-heading text-3xl md:text-4xl font-medium text-foreground mb-4" data-id="element-278">
              How Can We Help You?
            </h2>
            <p className="text-muted-foreground text-lg max-w-2xl mx-auto" data-id="element-279">
              Quick access to our most popular services and resources.
            </p>
          </div>
        </AnimateOnScroll>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-280">
          {actions.map((action, index) => <AnimateOnScroll key={index} delay={index * 0.1} data-id="element-281">
              <div className="group cursor-pointer bg-white rounded-2xl overflow-hidden border border-border/60 hover:border-primary/30 hover:shadow-xl transition-all duration-300 flex flex-col h-full" data-id="element-282">
                <div className="relative h-48 overflow-hidden" data-id="element-283">
                  <img src={action.image} alt={action.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-284" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" data-id="element-285" />
                  <div className="absolute bottom-3 left-3 bg-white/95 backdrop-blur-sm rounded-lg p-2.5 text-primary shadow-sm" data-id="element-286">
                    {action.icon}
                  </div>
                </div>
                <div className="flex flex-col flex-1 p-5" data-id="element-287">
                  <h3 className="font-heading text-lg font-medium text-foreground mb-2" data-id="element-288">
                    {action.title}
                  </h3>
                  <p className="text-muted-foreground text-sm leading-relaxed mb-4 flex-1" data-id="element-289">
                    {action.description}
                  </p>
                  <span className="inline-flex items-center gap-1.5 text-primary font-medium text-sm group-hover:gap-3 transition-all" data-id="element-290">
                    {action.cta}
                    <ArrowRight className="h-4 w-4" data-id="element-291" />
                  </span>
                </div>
              </div>
            </AnimateOnScroll>)}
        </div>
      </div>
    </section>;
}